export const DAY_OF_WEEK_OPTIONS = [
  { label: 'Sunday', value: 'sun' },
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thu' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' }
];

export const WEEK_OPTIONS = [
  { label: 'First', value: '#1' },
  { label: 'Second', value: '#2' },
  { label: 'Third', value: '#3' },
  { label: 'Fourth', value: '#4' },
  { label: 'Fifth', value: '#5' },
  { label: 'Last', value: 'l' }
];
